export const ADMIN_TREATMENT_GET = 'ADMIN_TREATMENT_GET';
export const ADMIN_TREATMENT_GET_SUCCESS = 'ADMIN_TREATMENT_GET_SUCCESS';
export const ADMIN_TREATMENT_GET_FAIL = 'ADMIN_TREATMENT_GET_FAIL';

export const ADMIN_TREATMENT_CLEAR = 'ADMIN_TREATMENT_CLEAR';
